@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.register-container {
  margin-top: 8rem;

  @include mobile {
    margin-top: 0;
    padding-top: 2.75rem;
  }
}

.container {
  margin-top: 2rem;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 5rem;
  max-width: 900px;
  width: 900px;

  @include mobile {
    width: 100%;
    padding-left: .5rem;
    padding-right: .5rem;
    padding-bottom: 0;
  }

  .info-text {
    text-align: center;
    margin-bottom: 2.5rem;
    font-weight: 300;
    color: $grey-text;

    @include mobile {
      margin-bottom: 1.5rem;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
    }
  }

  .error-wrapper {
    text-align: center;

    .error-message {
      margin-top: 1.25rem;
      margin-bottom: 4rem;
      display: flex;
      justify-content: center;

      @include mobile {
        margin-bottom: 1rem;
      }
    }
    .exclamation-point {
      margin-bottom: 0;
    }

    .link {
      text-decoration: underline;
      cursor: pointer;
    }

    .icon {
      &.exclamation svg {
        width: 1.75rem;
        height: 1.75rem;
        vertical-align: center;
      }
    }

    .solid {
      fill: $blue-info;
      stroke: none
    }
  }
}

.flex-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @include mobile {
    flex-wrap: wrap;
  }

  .column {
    display: flex;
    flex-direction: column;
    width: 25rem;

    @include mobile {
      width: 100%;
      padding: 1.5rem;
      margin-bottom: 1rem;

      &:first-child {
        padding-bottom: 0;
        margin-bottom: 0;
      }

      &:last-child {
        padding-top: 0;
      }
    }

    .required-info-container {
      .required-info {
        color: $grey;
        font-size: 0.75rem;
        line-height: 0.75rem;
        margin-top: 4.75rem;
        font-weight: 300;

        @include mobile {
          line-height: 0.875rem;
        }
      }

      @include mobile {
        display: none;
      }
    }
  }

  .mobile-only {
    @include mobile {
      .required-info-container {
        display: block;
        .required-info {
          margin-top: 2rem;
        }
      }
    }
    @include desktop {
      display: none;
    }
  }
}

.hide {
  display: none;
}

.spacer {
  flex: 1 auto;
}

.legals-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  margin-top: 1rem;
  margin-bottom: 4rem;

  @include mobile {
    width: 100%;
    padding-bottom: 1.5rem;
    margin-bottom: 0;
  }

  .privacy {
    color: $grey;
    font-size: 0.85rem;
    font-weight: 300;
    line-height: 1.125rem;

    a {
      color: $grey;
    }
  }
}

.register-button-wrapper {
  display: flex;
  flex-direction: row;
  align-items: baseline;

  .button-login {
    margin-right: 2rem;
  }

  @include mobile {
    align-items: center;
    flex-direction: column;
    margin: 0;

    .button-login {
      margin-bottom: 1rem;
      margin-right: 0;
      font-size: 1rem;
    }
  }
}

